<template>
  <div
    class="upsell-features grid w-full gap-3 md:grid-cols-3"
    data-testid="upsell-feature-grid"
  >
    <OwnCard
      v-for="feature in features"
      :key="feature.title"
      radius="16px"
      class="upsell-features__card items-start gap-4 p-4"
      :data-testid="`upsell-feature-card-${toTestId(feature.title)}`"
    >
      <span class="upsell-features__icon" aria-hidden="true">
        <component :is="feature.icon ?? SparklesSoft" :size="20" />
      </span>
      <div class="flex flex-col gap-1">
        <OwnType :text="feature.title" variant="title-small" color="primary" />
        <OwnType
          :text="feature.description"
          variant="paragraph-small"
          color="primary"
        />
      </div>
    </OwnCard>
  </div>
</template>

<script lang="ts" setup>
import { SparklesSoft } from '@owner/icons-vue/SparklesSoft'

import { OwnCard } from '@/ui/OwnCard'
import { OwnType } from '@/ui/OwnType'

import type { UpsellFeature } from '../types'
import { toTestId } from '../utils'

defineProps<{
  features: UpsellFeature[]
}>()
</script>

<style lang="scss" scoped>
// Dark feature cards from the tier-upgrades dark design — fixed palette, not
// theme tokens, because the cards always sit on the dark upsell surface.
.upsell-features {
  .upsell-features__card {
    background-color: #161918;
    border: 1px solid rgb(255 255 255 / 6%);
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 10px;
    color: #fff;
    background-color: #242826;
  }
}
</style>
